<template>
  <div class="card-type-manage">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>门店管理</el-breadcrumb-item>
      <el-breadcrumb-item>卡片类型管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片区域 -->
    <el-card class="box-card">
      <!-- 操作区域 -->
      <div class="header-actions">
        <el-button type="primary" icon="el-icon-plus" @click="showAddDialog">添加卡片类型</el-button>
        <el-button icon="el-icon-refresh" @click="loadCardTypes">刷新</el-button>
      </div>

      <!-- 卡片类型列表 -->
      <el-table :data="cardTypeList" border stripe v-loading="loading" style="width: 100%">
        <el-table-column prop="id" label="ID" width="80" align="center"></el-table-column>
        <el-table-column prop="cardType" label="类型标识" width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="cardName" label="卡片名称" width="120"></el-table-column>
        <el-table-column prop="cardDays" label="有效天数" width="100" align="center"></el-table-column>
        <el-table-column prop="sortOrder" label="排序" width="80" align="center"></el-table-column>
        <el-table-column label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.isEnabled"
              :active-value="1"
              :inactive-value="0"
              @change="handleStatusChange(scope.row)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ formatTime(scope.row.createTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="showEditDialog(scope.row)">编辑</el-button>
            <el-button type="danger" size="mini" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 添加卡片类型对话框 -->
    <el-dialog title="添加卡片类型" :visible.sync="addDialogVisible" width="500px" append-to-body>
      <el-form :model="addForm" :rules="formRules" ref="addForm" label-width="120px">
        <el-form-item label="类型标识" prop="cardType">
          <el-input v-model="addForm.cardType" placeholder="如：week_card" maxlength="50"></el-input>
          <span class="form-tip">英文标识，用于系统内部识别，如：week_card</span>
        </el-form-item>
        <el-form-item label="卡片名称" prop="cardName">
          <el-input v-model="addForm.cardName" placeholder="如：周卡" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item label="有效天数" prop="cardDays">
          <el-input-number v-model="addForm.cardDays" :min="1" :max="3650"></el-input-number>
          <span class="form-tip">天</span>
        </el-form-item>
        <el-form-item label="排序顺序" prop="sortOrder">
          <el-input-number v-model="addForm.sortOrder" :min="0" :max="999"></el-input-number>
          <span class="form-tip">数字越小越靠前</span>
        </el-form-item>
        <el-form-item label="是否启用">
          <el-switch v-model="addForm.isEnabled" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="addDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleAdd" :loading="submitting">确定添加</el-button>
      </div>
    </el-dialog>

    <!-- 编辑卡片类型对话框 -->
    <el-dialog title="编辑卡片类型" :visible.sync="editDialogVisible" width="500px" append-to-body>
      <el-form :model="editForm" :rules="formRules" ref="editForm" label-width="120px">
        <el-form-item label="类型标识">
          <el-input v-model="editForm.cardType" disabled></el-input>
          <span class="form-tip">类型标识不可修改</span>
        </el-form-item>
        <el-form-item label="卡片名称" prop="cardName">
          <el-input v-model="editForm.cardName" placeholder="如：周卡" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item label="有效天数" prop="cardDays">
          <el-input-number v-model="editForm.cardDays" :min="1" :max="3650"></el-input-number>
          <span class="form-tip">天</span>
        </el-form-item>
        <el-form-item label="排序顺序" prop="sortOrder">
          <el-input-number v-model="editForm.sortOrder" :min="0" :max="999"></el-input-number>
          <span class="form-tip">数字越小越靠前</span>
        </el-form-item>
        <el-form-item label="是否启用">
          <el-switch v-model="editForm.isEnabled" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleEdit" :loading="submitting">确定修改</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'CardTypeManage',
  data() {
    return {
      loading: false,
      submitting: false,
      cardTypeList: [],
      addDialogVisible: false,
      editDialogVisible: false,
      addForm: {
        cardType: '',
        cardName: '',
        cardDays: 7,
        sortOrder: 0,
        isEnabled: 1
      },
      editForm: {
        id: null,
        cardType: '',
        cardName: '',
        cardDays: 7,
        sortOrder: 0,
        isEnabled: 1
      },
      formRules: {
        cardType: [
          { required: true, message: '请输入类型标识', trigger: 'blur' },
          { pattern: /^[a-z_]+$/, message: '只能包含小写字母和下划线', trigger: 'blur' }
        ],
        cardName: [
          { required: true, message: '请输入卡片名称', trigger: 'blur' }
        ],
        cardDays: [
          { required: true, message: '请输入有效天数', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.loadCardTypes()
  },
  methods: {
    // 加载卡片类型列表
    async loadCardTypes() {
      this.loading = true
      try {
        const { data: res } = await this.$http.get('/cardType/list')
        if (res.status === 0) {
          // 转换字段名：下划线转驼峰
          this.cardTypeList = (res.data || []).map(item => ({
            id: item.id,
            cardType: item.card_type,
            cardName: item.card_name,
            cardDays: item.card_days,
            sortOrder: item.sort_order,
            isEnabled: item.is_enabled ? 1 : 0,
            createTime: item.create_time,
            updateTime: item.update_time
          }))
        } else {
          this.$message.error(res.message || '获取卡片类型列表失败')
        }
      } catch (error) {
        this.$message.error('网络错误：' + error.message)
      } finally {
        this.loading = false
      }
    },

    // 显示添加对话框
    showAddDialog() {
      this.addForm = {
        cardType: '',
        cardName: '',
        cardDays: 7,
        sortOrder: 0,
        isEnabled: 1
      }
      this.addDialogVisible = true
      this.$nextTick(() => {
        this.$refs.addForm && this.$refs.addForm.clearValidate()
      })
    },

    // 添加卡片类型
    async handleAdd() {
      this.$refs.addForm.validate(async (valid) => {
        if (!valid) return

        this.submitting = true
        try {
          const { data: res } = await this.$http.post('/cardType/add', this.addForm)
          if (res.status === 0) {
            this.$message.success('添加成功')
            this.addDialogVisible = false
            this.loadCardTypes()
          } else {
            this.$message.error(res.message || '添加失败')
          }
        } catch (error) {
          this.$message.error('网络错误：' + error.message)
        } finally {
          this.submitting = false
        }
      })
    },

    // 显示编辑对话框
    showEditDialog(row) {
      this.editForm = {
        id: row.id,
        cardType: row.cardType,
        cardName: row.cardName,
        cardDays: row.cardDays,
        sortOrder: row.sortOrder,
        isEnabled: row.isEnabled
      }
      this.editDialogVisible = true
      this.$nextTick(() => {
        this.$refs.editForm && this.$refs.editForm.clearValidate()
      })
    },

    // 编辑卡片类型
    async handleEdit() {
      this.$refs.editForm.validate(async (valid) => {
        if (!valid) return

        this.submitting = true
        try {
          const { data: res } = await this.$http.post('/cardType/update', this.editForm)
          if (res.status === 0) {
            this.$message.success('更新成功')
            this.editDialogVisible = false
            this.loadCardTypes()
          } else {
            this.$message.error(res.message || '更新失败')
          }
        } catch (error) {
          this.$message.error('网络错误：' + error.message)
        } finally {
          this.submitting = false
        }
      })
    },

    // 切换启用状态
    async handleStatusChange(row) {
      try {
        const { data: res } = await this.$http.post('/cardType/toggle', {
          id: row.id,
          isEnabled: row.isEnabled
        })
        if (res.status === 0) {
          this.$message.success(row.isEnabled === 1 ? '已启用' : '已禁用')
        } else {
          this.$message.error(res.message || '操作失败')
          row.isEnabled = row.isEnabled === 1 ? 0 : 1 // 恢复原状态
        }
      } catch (error) {
        this.$message.error('网络错误：' + error.message)
        row.isEnabled = row.isEnabled === 1 ? 0 : 1 // 恢复原状态
      }
    },

    // 删除卡片类型
    handleDelete(row) {
      this.$confirm(`确定要删除卡片类型"${row.cardName}"吗？删除后该类型将无法使用。`, '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const { data: res } = await this.$http.post('/cardType/delete', { id: row.id })
          if (res.status === 0) {
            this.$message.success('删除成功')
            this.loadCardTypes()
          } else {
            this.$message.error(res.message || '删除失败')
          }
        } catch (error) {
          this.$message.error('网络错误：' + error.message)
        }
      }).catch(() => {})
    },

    // 格式化时间
    formatTime(time) {
      if (!time) return '-'
      return time.replace('T', ' ').substring(0, 19)
    }
  }
}
</script>

<style scoped>
.card-type-manage {
  padding: 20px;
}

.box-card {
  margin-top: 15px;
}

.header-actions {
  margin-bottom: 15px;
}

.form-tip {
  color: #999;
  font-size: 12px;
  margin-left: 10px;
}
</style>
